var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-comparison"},[_c('router-view',{attrs:{"projectId":_vm.projectId,"decisionId":_vm.decisionId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }